import React from 'react'
import styled from 'styled-components'
import { ReactComponent as Circle } from '../../../assets/upload-circle.svg'

const Card = styled.div`
  width: 100%;
  height: 100%;
  min-height: 176px;
  position: relative;
  border-radius: 10px;
  user-select: none;
  cursor: pointer;
  background-color: ${props => props.theme.card.primary};
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`

const InnerContainer = styled.div`
  position: absolute;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Title = styled.div`
  margin-top: 8px;
  /*color: #8b8b8b;*/
  font-weight: 500;
  font-size: 16px;
`

const Empty = styled.div`
  height: 25px;
`

const DesignAddCard = ({ title, info, children, onClick }) => {
  return (
    <Card onClick={onClick}>
      <InnerContainer>
        <Circle />
        {title && <Title>{title}</Title>}
        {!title && <Title>Upload</Title>}
        {info ? <Title>{info}</Title> : <Empty />}
      </InnerContainer>
      {children}
    </Card>
  )
}

export default DesignAddCard
